export default {
  host: process.env.VUE_APP_PEYK_HOST || "https://api.pass.qa/api/",
  os_type: process.env.VUE_APP_PEYK_OS_TYPE || "WEB",
  os_info: process.env.VUE_APP_PEYK_OS_INFO || "Chrome V.91",
  api_version: process.env.VUE_APP_PEYK_API_VERSION || 1,
  app_version: process.env.VUE_APP_PEYK_APP_VERSION || 1,
  app_type: process.env.VUE_APP_PEYK_APP_TYPE || "CUSTOMER",
  stripe_key:
    process.env.VUE_APP_PEYK_STRIPE_KEY || "pk_live_QPgHKvXeV1BCVbZVPc1jAJA3",
};